/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';

export const interviewFiltersSchema = z.object({ "assigneeType": z.string().nullish(), "interviewStatus": z.string().nullish() });
export type InterviewFilters = z.infer<typeof interviewFiltersSchema>;
